module.exports = __webpack_public_path__ + "assets/images/novasports_start.548a6eb56ad83e3687bfe19e465dea8e.png";